import React, { useEffect, useState } from "react";
import "../Styles/style.css";
import NotAvailable from "../../images/not-found.json";
import Waiting from "../../images/clock.json";
import axios from "axios";
import PaymentRejected from "../modals/payment-rejected.jsx";
import { useHistory } from "react-router-dom";
import { baseUrl } from "../../api/ipconfig.js";
import { AuthContext } from "../../context/AuthContext.js";
import BecomeMember from "../../images/become-member.png";
import { Alert, Snackbar } from "@mui/material";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Modal,
} from "@mui/material";
import JazzCashLogo from "../../images/jazzcash-logo.png";
import PayFastLogo from "../../images/PayFastLogo.png";
import Lottie from "lottie-react";
import PaymentSuccess from "../modals/payment-success.jsx";

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

export default function PayFast() {
  const { user } = React.useContext(AuthContext);
  const token = localStorage.getItem("token");

  const [gateway, setGateway] = useState("PayFast");
  const [email, setEmail] = useState("test@gmail.com");
  const [phone, setPhone] = useState(123456789);

  const [error, setError] = useState("");
  const [value, setValue] = useState(5);
  const [successIsOpen, setSuccessIsOpen] = React.useState(false);
  const [rejectedOpen, setRejectedOpen] = useState(false);
  const [tokenLoading, setTokenLoading] = useState(false);
  const [tokenResponse, setTokenResponse] = useState("");
  const [randomNo, setRandomNo] = useState("");
  const [paymentResponse, setPaymentResponse] = useState({});
  const [openFaildModal, setOpenFaildModal] = useState(false);
  const [openWaitingModal, setOpenWaitingModal] = useState(false);
  const [vehicleDetail, setVehicleDetail] = useState(null);
  const [auctionDetail, setAuctionDetail] = useState(null);
  const [errOpen, setErrOpen] = React.useState(false);
  const successClose = () => {
    setSuccessIsOpen(false);
  };

  const rejectedClose = () => {
    setRejectedOpen(false);
  };

  const history = useHistory();

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    //PayFast Parameters
    const responseCode = params.get("err_code");
    const responseMessage = params.get("err_msg");
    const responseAmount = params.get("transaction_amount");
    const responseTransactionId = params.get("transaction_id");
    const responseBasketId = params.get("basket_id");

    if (params?.size > 0) {
      if (
        responseCode === "000" ||
        responseCode === "200" ||
        responseCode === "121"
      ) {
        if (
          responseCode &&
          responseAmount &&
          responseTransactionId &&
          responseBasketId &&
          responseMessage
        ) {
          const method = "PayFast";

          getInspectionUpdate(
            responseAmount,
            responseTransactionId,
            responseBasketId,
            method
          );

          setPaymentResponse({
            responseMessage,
            responseAmount,
            responseTransactionId,
            responseBasketId,
          });
        } else {
        }
      } else if (
        responseCode === "90" ||
        responseCode === "002" ||
        responseCode === "001" ||
        responseCode === "97" ||
        responseCode === "106" ||
        responseCode === "3" ||
        responseCode === "14" ||
        responseCode === "54" ||
        responseCode === "13" ||
        responseCode === "126" ||
        responseCode === "75" ||
        responseCode === "14" ||
        responseCode === "15" ||
        responseCode === "42" ||
        responseCode === "423" ||
        responseCode === "41" ||
        responseCode === "801" ||
        responseCode === "802" ||
        responseCode === "803" ||
        responseCode === "804" ||
        responseCode === "805" ||
        responseCode === "806" ||
        responseCode === "807" ||
        responseCode === "808" ||
        responseCode === "809" ||
        responseCode === "810" ||
        responseCode === "811" ||
        responseCode === "812" ||
        responseCode === "813" ||
        responseCode === "850" ||
        responseCode === "851" ||
        responseCode === "79" ||
        responseCode === "901" ||
        responseCode === "9000"
      ) {
        if (
          responseCode &&
          responseAmount &&
          responseTransactionId &&
          responseBasketId &&
          responseMessage
        ) {
          setPaymentResponse({
            responseMessage,
            responseAmount,
            responseTransactionId,
            responseBasketId,
          });
        }
        setOpenFaildModal(true);

        setTimeout(() => {
          setOpenFaildModal(false);
          history.push("/PayFast");
        }, 4000);
      } else {
      }
    }
  }, []);
  const getInspectionUpdate = async (
    responseAmount,
    responseTransactionId,
    responseBasketId,
    method
  ) => {
    try {
      setOpenWaitingModal(true);
      const response = await axios.get(`${baseUrl}/savetokenamount`, {
        params: {
          payment_method: method,
          security_deposit: responseAmount,
          order_id: responseBasketId,
          payment_token: responseTransactionId,
          payment_status: 1,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSuccessIsOpen(true);
      setOpenWaitingModal(false);
      setTimeout(() => {
        setSuccessIsOpen(false);
        history.push("/PayFast");
      }, 4000);
    } catch (error) {
      setError(error?.response?.data?.error);
      setErrOpen(true);
      setOpenWaitingModal(false);
      setTimeout(() => {
        history.push("/PayFast");
      }, 3000);
      console.error(error);
    }
  };
  const extractPostIdFromUrl = (url) => {
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  const url = window.location.href;
  const auctionPostId = extractPostIdFromUrl(url);

  React.useEffect(() => {
    const getAccessToken = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${baseUrl}/gettoken`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setTokenResponse(response?.data);
        setTokenLoading(true);
      } catch (error) {
        console.error(error);
      }
    };

    getAccessToken();
    const generateRandomNumber = () => {
      const min = 1; // Minimum value
      const max = 100; // Maximum value
      const randomNum = Math.floor(Math.random() * (max - min + 1)) + min; // Generate random number within the range
      setRandomNo(randomNum); // Update state with the generated random number
    };
    generateRandomNumber();
  }, []);

  const currentDate = new Date();
  const date = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${currentDate
    .getDate()
    .toString()
    .padStart(2, "0")} ${currentDate
    .getHours()
    .toString()
    .padStart(2, "0")}:${currentDate
    .getMinutes()
    .toString()
    .padStart(2, "0")}:${currentDate.getSeconds().toString().padStart(2, "0")}`;

  const handlePayFastFormSubmit = () => {
    // Once the form data is available, construct the form dynamically
    const form = document.createElement("form");
    form.method = "POST";
    form.id = "PayFast_payment_form";
    form.name = "PayFast-payment-form";
    form.action =
      "https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction";

    // Add the name field from the state to the form
    const SUCCESSURL = document.createElement("input");
    SUCCESSURL.type = "hidden";
    SUCCESSURL.name = "SUCCESS_URL";
    SUCCESSURL.value = `https://www.famewheels.com/PayFast`;
    form.appendChild(SUCCESSURL);

    const FAILUREURL = document.createElement("input");
    FAILUREURL.type = "hidden";
    FAILUREURL.name = "FAILURE_URL";
    FAILUREURL.value = `https://www.famewheels.com/PayFast`;
    form.appendChild(FAILUREURL);

    const CHECKOUTURL = document.createElement("input");
    CHECKOUTURL.type = "hidden";
    CHECKOUTURL.name = "CHECKOUT_URL";
    CHECKOUTURL.value = "https://www.famewheels.com/";
    form.appendChild(CHECKOUTURL);

    const CUSTOMEREMAIL = document.createElement("input");
    CUSTOMEREMAIL.type = "hidden";
    CUSTOMEREMAIL.name = "CUSTOMER_EMAIL_ADDRESS";
    CUSTOMEREMAIL.value = email;
    form.appendChild(CUSTOMEREMAIL);

    const CUSTOMERMOBILENO = document.createElement("input");
    CUSTOMERMOBILENO.type = "hidden";
    CUSTOMERMOBILENO.name = "CUSTOMER_MOBILE_NO";
    CUSTOMERMOBILENO.value = phone;
    form.appendChild(CUSTOMERMOBILENO);

    const TXNAMTInput = document.createElement("input");
    TXNAMTInput.type = "hidden";
    TXNAMTInput.name = "TXNAMT";
    TXNAMTInput.value = value;
    form.appendChild(TXNAMTInput);

    const BASKETID = document.createElement("input");
    BASKETID.type = "hidden";
    BASKETID.name = "BASKET_ID";
    BASKETID.value = `${randomNo}`;
    form.appendChild(BASKETID);

    const ORDERDATE = document.createElement("input");
    ORDERDATE.type = "hidden";
    ORDERDATE.name = "ORDER_DATE";
    ORDERDATE.value = tokenResponse?.GENERATED_DATE_TIME;
    form.appendChild(ORDERDATE);

    const SOMERANDOMSTRING = document.createElement("input");
    SOMERANDOMSTRING.type = "hidden";
    SOMERANDOMSTRING.name = "SIGNATURE";
    SOMERANDOMSTRING.value = "SOMERANDOM-STRING";
    form.appendChild(SOMERANDOMSTRING);

    const MERCHANTCART = document.createElement("input");
    MERCHANTCART.type = "hidden";
    MERCHANTCART.name = "VERSION";
    MERCHANTCART.value = "MERCHANT-CART0.1";
    form.appendChild(MERCHANTCART);

    // Add the name field from the state to the form
    const TXNDESCInput = document.createElement("input");
    TXNDESCInput.type = "hidden";
    TXNDESCInput.name = "TXNDESC";
    TXNDESCInput.value = "Item Purchased from Cart";
    form.appendChild(TXNDESCInput);

    // Add the name field from the state to the form
    const PROCCODEInput = document.createElement("input");
    PROCCODEInput.type = "hidden";
    PROCCODEInput.name = "PROCCODE";
    PROCCODEInput.value = "00";
    form.appendChild(PROCCODEInput);

    // Add the name field from the state to the form
    const ECOMMPURCHASE = document.createElement("input");
    ECOMMPURCHASE.type = "hidden";
    ECOMMPURCHASE.name = "TRAN_TYPE";
    ECOMMPURCHASE.value = "ECOMM_PURCHASE";
    form.appendChild(ECOMMPURCHASE);

    // Add the name field from the state to the form
    const STOREID = document.createElement("input");
    STOREID.type = "hidden";
    STOREID.name = "STORE_ID";
    STOREID.value = "";
    form.appendChild(STOREID);

    // Add the name field from the state to the form
    const RECURRINGTXN = document.createElement("input");
    RECURRINGTXN.type = "hidden";
    RECURRINGTXN.name = "RECURRING_TXN";
    RECURRINGTXN.value = "true";
    form.appendChild(RECURRINGTXN);

    // Add the name field from the state to the form
    const CURRENCYCODE = document.createElement("input");
    CURRENCYCODE.type = "hidden";
    CURRENCYCODE.name = "CURRENCY_CODE";
    CURRENCYCODE.value = "PKR";
    form.appendChild(CURRENCYCODE);

    const MERCHANTID = document.createElement("input");
    MERCHANTID.type = "hidden";
    MERCHANTID.name = "MERCHANT_ID";
    MERCHANTID.value = 20579;
    form.appendChild(MERCHANTID);

    const ACCESSTOKEN = document.createElement("input");
    ACCESSTOKEN.type = "hidden";
    ACCESSTOKEN.name = "TOKEN";
    ACCESSTOKEN.value = tokenResponse?.ACCESS_TOKEN;
    form.appendChild(ACCESSTOKEN);

    // Append the form to the document body and submit it programmatically
    document.body.appendChild(form);
    form.submit();
  };

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  useEffect(() => {
    if (vehicleDetail?.highestbidamount <= 1000000) {
      setValue(10000);
    } else if (
      vehicleDetail?.highestbidamount > 1000000 &&
      vehicleDetail?.highestbidamount <= 2500000
    ) {
      setValue(20000);
    } else if (
      vehicleDetail?.highestbidamount > 2500000 &&
      vehicleDetail?.highestbidamount <= 5000000
    ) {
      setValue(30000);
    } else if (
      vehicleDetail?.highestbidamount > 5000000 &&
      vehicleDetail?.highestbidamount <= 7500000
    ) {
      setValue(40000);
    } else if (
      vehicleDetail?.highestbidamount > 7500000 &&
      vehicleDetail?.highestbidamount <= 10000000
    ) {
      setValue(50000);
    } else if (vehicleDetail?.highestbidamount > 10000000) {
      setValue(100000);
    }
  });

  const handleChange = (event, value) => {
    setGateway(value?.props?.value);
  };

  const handleBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setErrOpen(false);
  };
  return (
    <>
      <Snackbar
        open={errOpen}
        autoHideDuration={6000}
        onClose={handleBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleBarClose} severity="error" sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>
      <PaymentSuccess
        open={successIsOpen}
        onClose={successClose}
        response={paymentResponse}
      />
      <PaymentRejected open={rejectedOpen} onClose={rejectedClose} />
      <div className="container-fluid grad-bg90 py-4 ">
        <div className="container">
          <div className="row align-items-center ">
            <div className="col-lg-7 col-12">
              <h2 className=" color-white text-start fw-bold fs-1">
                Test PayFast
              </h2>
            </div>
            <div className="col-lg-5 col-md-12 col-12 text-end p-0">
              <img
                className="topBanner_img img-fluid "
                src={BecomeMember}
                alt="Sell through live bidding"
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="container py-5">
          <div className="p-3 pb-5">
            <div className="row boxShadow m-2 biddingCard">
              <div className="  col-12 ">
                <div className="vehicleTab1 pt-3">
                  <h2 className="text-center fs-3 fw-700">
                    Amount:{" "}
                    <span className=" color-secondary">
                      PKR {formatPrice(value)}
                    </span>
                  </h2>

                  <div className="row my-3">
                    <div className="d-flex justify-content-center ">
                      <Box sx={{ width: 500 }}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Payment Gateway
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={gateway}
                            label="Payment Gateway"
                            onChange={handleChange}
                          >
                            <MenuItem value={"PayFast"} sx={{ width: 500 }}>
                              <div className="w-100 d-flex justify-content-center gap-3">
                                <img
                                  src={PayFastLogo}
                                  className="logoIcons img-fluid"
                                  alt=""
                                />{" "}
                              </div>
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center mt-3 mb-5">
                    {gateway && gateway === "PayFast" ? (
                      <button
                        onClick={handlePayFastFormSubmit}
                        type="submit"
                        style={{ width: "fit-content" }}
                        className="btn mt-3 fw-primary model_loginBTn px-4 py-1 fw-500 fs-5 "
                        disabled={tokenLoading !== true}
                      >
                        Proceed to payment
                      </button>
                    ) : (
                      <button
                        type="submit"
                        style={{ width: "fit-content" }}
                        className="btn mt-3 fw-primary model_loginBTn px-4 py-1 fw-500 fs-5 "
                        disabled={true}
                      >
                        Proceed to payment
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={openFaildModal}
        onClose={() => setOpenFaildModal(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <div className="text-center py-2">
            <h2 className="color-secondary">Payment Canceled</h2>
          </div>
          <p className="m-0 p-0">{paymentResponse?.responseMessage}</p>
          <p className="pt-1">We will contact you soon. Thank You!</p>
        </Box>
      </Modal>
      <Modal
        open={openWaitingModal}
        onClose={() => setOpenWaitingModal(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <div className="text-center py-2">
            <Lottie style={{ height: 200 }} animationData={Waiting} loop />
            <h2 className="color-secondary">Wait</h2>
          </div>
          <p className="pt-1">Do not close this window.</p>
        </Box>
      </Modal>
    </>
  );
}
